<label (click)="toggleCheckbox($event)"
       [class.disabled]="disabled"
       [class.margin-none]="noMargin"
       [class.readonly]="readonly"
       [class.work-ui-checkbox--card]="cardStyle"
       [ngClass]="{ 'work-action-element': cardStyle }"
       class="work-ui-checkbox"
       data-testid="checkbox__native-label">
  <span class="flex flex-column">
    @if (labelBold) {
      <b>{{ label | translate }}</b>
    } @else {
      {{ label | translate }}
    }
    @if (description) {
      <small>{{ description | translate }}</small>
    }
  </span>
  <ng-content></ng-content>
  <input
    (blur)="onTouched()"
    [checked]="checked"
    [disabled]="disabled"
    [name]="name"
    type="checkbox"
    data-testid="checkbox__native-input" />
  <span class="work-ui-checkbox__checkmark"></span>
</label>
